import { gql } from '@apollo/client';

export const SITE_FIELDS = gql`
  fragment SiteFields on Site {
    id
    name
    description
    clientId
    tenantId
    status
    contactNumber
    primaryContactId
    address {
      addressLine1
      addressLine2
      addressFriendly
      suburb
      state
      postcode
      countryLabel
      countryValue
    }
    latLng {
      lat
      lng
    }
    customAttributes {
      ref
      value
    }
    createdAt
  }
`;

export const GET_SITES_FOR_CLIENT = gql`
  ${SITE_FIELDS}
  query GetSitesForClient($clientId: String!, $status: [SiteStatus!]) {
    getSitesForClient(clientId: $clientId, status: $status) {
      ...SiteFields
    }
  }
`;

export const GET_SITE = gql`
  ${SITE_FIELDS}
  query GetSite($id: String!) {
    getSite(id: $id) {
      ...SiteFields
    }
  }
`;

export const CREATE_SITE = gql`
  ${SITE_FIELDS}
  mutation CreateSite($details: SiteInput!) {
    createSite(details: $details) {
      ...SiteFields
    }
  }
`;

export const UPDATE_SITE = gql`
  ${SITE_FIELDS}
  mutation UpdateSite($id: String!, $details: SiteInput!) {
    updateSite(id: $id, details: $details) {
      ...SiteFields
    }
  }
`;

export const SET_SITE_STATUS = gql`
  ${SITE_FIELDS}
  mutation SetSiteStatus($id: String!, $status: SiteStatus!) {
    setSiteStatus(id: $id, status: $status) {
      ...SiteFields
    }
  }
`;

export const SET_ACCOUNTS_FOR_SITE = gql`
  mutation SetAccountsForSite(
    $siteId: String!
    $clientUserIds: [String!]
    $inviteIds: [String!]
  ) {
    setAccountsForSite(
      siteId: $siteId
      clientUserIds: $clientUserIds
      inviteIds: $inviteIds
    ) {
      id
      firstName
      lastName
      email
      role
      siteIds
    }
  }
`;

export const SET_SITES_FOR_ACCOUNT = gql`
  mutation SetSitesForAccount(
    $clientUserId: String
    $inviteId: String
    $siteIds: [String!]!
  ) {
    setSitesForAccount(
      clientUserId: $clientUserId
      inviteId: $inviteId
      siteIds: $siteIds
    )
  }
`;
